import Component from '../../../shared/component';

export default class ConversationArchiveButton extends Component {
  constructor(element) {
    super(...arguments);

    this.$element = $(element);

    const containerClass = this.$element.data('container');
    this.$container = this.$element.parents(`.${containerClass}`);

    this.bindEvents();
  }

  bindEvents() {
    this.handleClick = this.handleClick.bind(this);

    this.$element.on('click.ConversationArchiveButton', this.handleClick);
  }

  unbindEvents() {
    this.$element.off('click.ConversationArchiveButton', this.handleClick);
  }

  handleClick(event) {
    event.preventDefault();

    // eslint-disable-next-line no-alert
    if (window.confirm(this.$element.data('alert'))) {
      const url = this.$element.data('url');
      const type = this.$element.data('method');

      $.ajax({url, type}).done(() => this.handleAjaxSuccess());
    }
  }

  handleAjaxSuccess() {
    // NOTE: If the conversation is the currently active one, we have
    //       to redirect to the conversations index for the first one to
    //       be selected. Otherwise, we can simply reload the page.
    if (this.$container.hasClass('sidebarList-list-item--active')) {
      window.Turbolinks.visit(this.$element.data('redirect-url'));
    } else {
      window.Turbolinks.reload();
    }
  }
}
